export const MULTI_LEVEL_MENU_CONSTANT = {
  PADDING_AT_START: true,
  DEFAULT_LIST_CLASS_NAME: `sx-multilevel-sidenav__list-item`,
  SELECTED_LIST_CLASS_NAME: `sx-multilevel-sidenav__list-item--selected`,
  ACTIVE_ITEM_CLASS_NAME: `sx-multilevel-sidenav__list-item--active`,
  DISABLED_ITEM_CLASS_NAME: `sx-multilevel-sidenav__list-item--disabled`,
  DEFAULT_HREF_TARGET_TYPE: '_self'
};
